exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".options-row[data-v-0a911f04]{display:-webkit-box;display:-ms-flexbox;display:flex}@media (max-width:530px){.options-row[data-v-0a911f04]{display:block;text-align:right}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a911f04","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/office/admin/users/UserEventsList.vue
// module id = ibqU
// module chunks = 0